import {
    server
} from "@/api";

const prefix = 'api/me'

export const companies = async (params = {}) => {
    return await server().get(`${prefix}/companies`, { params });
}

export const actAsCompany = async (companyId) => {
    return await server().post(`${prefix}/act-as-company/${companyId}`);
}

export const stopActingAsCompany = async () => {
    return await server().post(`${prefix}/stop-acting-as-company`);
}

export const updateProfile = async (data) => {
    // data can be a plain object or FormData (when uploading a new profile image)
    const isFormData = data instanceof FormData;
    return await server().post(`${prefix}/profile`, data, {
        headers: isFormData ? { 'Content-Type': 'multipart/form-data' } : {},
    });
}

const meApi = {
    companies,
    actAsCompany,
    stopActingAsCompany,
    updateProfile,
}

export default meApi;
